import { render, staticRenderFns } from "./modificationManagement.vue?vue&type=template&id=61bca76c&scoped=true"
import script from "./modificationManagement.vue?vue&type=script&lang=js"
export * from "./modificationManagement.vue?vue&type=script&lang=js"
import style0 from "./modificationManagement.vue?vue&type=style&index=0&id=61bca76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bca76c",
  null
  
)

export default component.exports